import { render } from "./CompanyData.vue?vue&type=template&id=7574d96b&ts=true&class=w-screen%20mb-8"
import script from "./CompanyData.vue?vue&type=script&lang=ts"
export * from "./CompanyData.vue?vue&type=script&lang=ts"

import "./CompanyData.vue?vue&type=style&index=0&id=7574d96b&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__